module.exports = __webpack_public_path__ + "static/img/icon2-5.c338c981.svg";